import { db } from '@/firebase.js'
import { functions } from '@/assets/script/functions.js'
import searchHelper from '@/helpers/searchHelper'

const recipes = {
  state: {
    recipeUrl: '',
    AllRecipes: [],
    Favorites: [],
    Done: []
  },
  mutations: {
    setRecipeUrl(state, url){
      state.recipeUrl = url
    },
    setRecipesData(state, recipes){
      state.AllRecipes = recipes
    },
    setDone(state, list){
      state.Done = list
    },
    setFavorites(state, list){
      state.Favorites = list
    }
  },
  actions: {
    async initRecipes({dispatch}){
      await dispatch('getRecipeData')
      await dispatch('getFavorites')
      dispatch('getDone')
    },
    // Gets all recipes from firebase
    async getRecipeData({commit}){
      const collectionData = await db.collection('RecipeData').get()
      const recipeData = collectionData.docs.map(doc => doc.data())
      commit('setRecipesData', recipeData)
    },
    // Get favorites from firebase
    async getFavorites({commit}){
      const firestoreData = await db.collection('FavoriteRecipes').get()
      const favorites = firestoreData.docs.map(doc => doc.id)
      commit('setFavorites', favorites)
    },
    // Get done from firebase
    getDone({commit, state}){
      // const firestoreData = await db.collection('DoneRecipes').get()
      const done = state.AllRecipes.filter(recipe => recipe.Done).map(recipe => recipe.Id.toString());
      commit('setDone', done)
    }
  },
  getters: {
    allRecipes: (state) => functions.getUnique(state.AllRecipes, 'Title'),
    getRecipeById: state => url => state.AllRecipes.find(recipe => recipe.Url == url),
    getThisRecipe: state => state.AllRecipes.find(recipe => recipe.Url == state.recipeUrl),
    getXSimilarRecipes: (state, getters) => x => {
      let categories = getters.getThisRecipe.Categories.map(category => category.Name)
      let searchResult = searchHelper.search(categories, getters.allRecipes)
      while(searchResult.length < x){
        categories.pop()
        searchResult = searchHelper.search(categories, getters.allRecipes)
      }
      return searchResult.filter(result => result.Id != getters.getThisRecipe.Id).splice(0,x)
    },
    getRecipeDoneById: state => id => state.Done.includes(id.toString()),
    getRecipeFavoriteById: state => id => state.Favorites.includes(id.toString()),
    getFavorites: state => state.Favorites,
    getDone: state => state.Done
  }
}
export default recipes